
import DrawBase from "../DrawBase"
import EditRectangleP from "./EditRectangleP"
import { cartesians2lonlats, lonlats2cartesians } from "../../utils/CoordinateUtil.js"

class DrawRectangleP extends DrawBase {

    constructor(options) {
        super(options);

        //this.options.style = { material: "data/gg.svg" }
    }

    getEditInterface(){
        return EditRectangleP;
    }

    getType() {
        return "rectangle_NorP";
    }

    checkLeftClick() {
        if (this.positionsTemp.length < 2) {
            return true;
        }
        return false;
    }
    calculateKeyPositions() {
        if (this.positionsTemp.length == 2) {
            var lonlats = cartesians2lonlats(this.positionsTemp);
            var p_B = [lonlats[1][0], lonlats[0][1], lonlats[0][2]];
            var p_D = [lonlats[0][0], lonlats[1][1], lonlats[1][2]];
            var cartesians = lonlats2cartesians([lonlats[0], p_B, lonlats[1], p_D, lonlats[0]]);
            this.positions = cartesians;
            return;
        }

        this.positions = this.positionsTemp;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
                return new $this.Cesium.PolygonHierarchy(positionsArr);
            }
            return new $this.Cesium.PolygonHierarchy(positionsArr ? positionsArr : $this.positions);
        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

}

export default DrawRectangleP;